import React from "react";
import Image from "next/image";
import cx from "classnames";
import st from "./paymentImage.module.scss";

interface PaymentImageProps {
  className?: string;
  isHighlighted?: boolean;
  src: string | undefined;
}

export function PaymentImage({
  className,
  isHighlighted,
  src,
}: PaymentImageProps): JSX.Element {
  const pillowClassNames = cx(st.pillow, {
    [st.highlighted]: isHighlighted,
  });

  return (
    <div className={className} data-testid="payment-image">
      <span className={pillowClassNames}>
        <Image src={src || "/"} layout="fill" alt="payment" />
      </span>
    </div>
  );
}
